<template>
  <div>
    <div class="main-title">收支报表</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="user.buttons.indexOf(1020) < 0"
              :picker-options="datePickerOptions"
              @change="search">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <el-row :gutter="16">
        <!-- 按项目统计 -->
        <el-col :span="8">
          <div class="report-section-header">
            <span class="report-section-title">按项目统计</span>
            <el-button-group>
              <el-button icon="el-icon-download" size="mini" @click="exportItemExcel" :loading="itemExporting"></el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="fetchItemList" :loading="itemLoading"></el-button>
            </el-button-group>
          </div>
          <el-table
            :data="itemList"
            stripe
            border
            :height="tableHeight - 60"
            size="small"
            show-summary
            :summary-method="itemSummaryMethod"
            style="width:100%">
            <el-table-column prop="name" label="项目名称" width="120"></el-table-column>
            <el-table-column prop="total_in" label="累计收入" align="right"></el-table-column>
            <el-table-column prop="total_out" label="累计支出" align="right"></el-table-column>
            <el-table-column prop="balance" label="结余" align="right"></el-table-column>
          </el-table>
        </el-col>
        <!-- 按账户统计 -->
        <el-col :span="16">
          <div class="report-section-header">
            <span class="report-section-title">按账户统计</span>
            <el-checkbox v-model="hideZero" style="margin-left: 12px">隐藏收支为0的账户</el-checkbox>
            <el-button-group style="margin-left: auto">
              <el-button icon="el-icon-download" size="mini" @click="exportAccountExcel" :loading="accountExporting"></el-button>
              <el-button icon="el-icon-printer" size="mini" @click="print"></el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="fetchAccountList" :loading="accountLoading"></el-button>
            </el-button-group>
          </div>
          <el-table
            :data="filteredAccountList"
            stripe
            border
            :height="tableHeight - 60"
            size="small"
            show-summary
            :summary-method="accountSummaryMethod"
            style="width:100%">
            <el-table-column prop="name" label="账户名称" width="120"></el-table-column>
            <el-table-column prop="start_balance" label="期初余额" align="right"></el-table-column>
            <el-table-column prop="total_in" label="累计收入" align="right"></el-table-column>
            <el-table-column prop="total_out" label="累计支出" align="right"></el-table-column>
            <el-table-column prop="balance" label="结余" align="right"></el-table-column>
            <el-table-column prop="cumulative_in" label="累计转入" align="right"></el-table-column>
            <el-table-column prop="cumulative_out" label="累计转出" align="right"></el-table-column>
            <el-table-column prop="end_balance" label="期末余额" align="right"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import DatePickerOptions from '../../mixins/DatePickerOptions'
import NP from 'number-precision'
import moment from 'moment'
export default {
  mixins: [DatePickerOptions],
  props: {
    tableHeight: Number,
    user: Object
  },
  data () {
    return {
      searchForm: {
        daterange: [new Date(), new Date()]
      },
      hideZero: true,
      itemList: [],
      itemLoading: false,
      accountList: [],
      accountLoading: false,
      itemExporting: false,
      accountExporting: false
    }
  },
  computed: {
    searchParams () {
      const params = {}
      if (this.searchForm.daterange && this.searchForm.daterange.length > 0) {
        params.daterange_start = moment(this.searchForm.daterange[0]).format('YYYY-MM-DD')
        params.daterange_end = moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      return params
    },
    filteredAccountList () {
      if (this.hideZero) {
        return this.accountList.filter(row =>
          row.total_in != 0 || row.total_out != 0 || row.cumulative_in != 0 || row.cumulative_out != 0
        )
      }
      return this.accountList
    }
  },
  watch: {
    hideZero () {
      this.fetchAccountList()
    }
  },
  mounted () {
    this.search()
  },
  methods: {
    search () {
      this.fetchItemList()
      this.fetchAccountList()
    },
    fetchItemList () {
      this.itemLoading = true
      this.$http.get('/dbapi/finance_report_item', {
        params: {
          ...this.searchParams,
          hideZero: this.hideZero ? '1' : '0'
        }
      }).then(response => {
        this.itemLoading = false
        if (response.data.success) {
          this.itemList = response.data.list
        } else {
          this.$message({ type: 'error', message: response.data.message })
        }
      })
    },
    fetchAccountList () {
      this.accountLoading = true
      this.$http.get('/dbapi/finance_report', {
        params: {
          ...this.searchParams,
          hideZero: this.hideZero ? '1' : '0'
        }
      }).then(response => {
        this.accountLoading = false
        if (response.data.success) {
          this.accountList = response.data.list
        } else {
          this.$message({ type: 'error', message: response.data.message })
        }
      })
    },
    itemSummaryMethod ({ columns, data }) {
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        sums[index] = values.reduce((prev, curr) => {
          if (!isNaN(curr)) {
            return NP.plus(prev, curr)
          }
          return prev
        }, 0)
      })
      return sums
    },
    accountSummaryMethod ({ columns, data }) {
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        sums[index] = values.reduce((prev, curr) => {
          if (!isNaN(curr)) {
            return NP.plus(prev, curr)
          }
          return prev
        }, 0)
      })
      return sums
    },
    exportItemExcel () {
      if (this.itemExporting) return
      this.itemExporting = true
      this.$http.get('/dbapi/excel/finance_report_item', {
        params: {
          ...this.searchParams,
          hideZero: this.hideZero ? '1' : '0'
        }
      }).then(response => {
        this.itemExporting = false
        if (response.data.success) {
          this.$alert('导出成功,点击下载文件', '导出成功', {
            confirmButtonText: '下载文件',
            callback: () => {
              window.open(response.data.url)
            }
          })
        } else {
          this.$message({ type: 'error', message: '导出失败,' + response.data.message })
        }
      })
    },
    exportAccountExcel () {
      if (this.accountExporting) return
      this.accountExporting = true
      this.$http.get('/dbapi/excel/finance_report', {
        params: {
          ...this.searchParams,
          hideZero: this.hideZero ? '1' : '0'
        }
      }).then(response => {
        this.accountExporting = false
        if (response.data.success) {
          this.$alert('导出成功,点击下载文件', '导出成功', {
            confirmButtonText: '下载文件',
            callback: () => {
              window.open(response.data.url)
            }
          })
        } else {
          this.$message({ type: 'error', message: '导出失败,' + response.data.message })
        }
      })
    },
    print () {
      window.print()
    }
  }
}
</script>

<style scoped>
.report-section-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.report-section-title {
  font-size: 14px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/finance/Report.vue